module.exports = __webpack_public_path__ + "static/img/img-advantage4.071501d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-advantage4.svg
// module id = rIGU
// module chunks = 0